import styleInject from 'style-inject';
import { collectStyles } from '@lsg/ssr';

var reactStyles = " .lsgs-b1d71--tabs{display:block;} .lsgs-b1d71--tabs:not(.lsgs-b1d71--no-margin){margin-bottom:16px;}@media screen and (min-width:1024px){ .lsgs-b1d71--tabs:not(.lsgs-b1d71--no-margin){margin-bottom:24px;}}.lsgs-b1d71--tabs-panel{margin:48px 0;}";
var hostClass = "lsgs-b1d71--tabs";
styleInject(reactStyles);
collectStyles(reactStyles);

export { hostClass, reactStyles };
